import axios from 'axios';
import { API_URL } from 'clicker-common/src/Config';
import { DEV_MODE } from '../state/Config';

const apiClient = axios.create({
  baseURL: DEV_MODE ? API_URL : '',
});

export const setAuthHeader = (token) => {
  if (token) {
    apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common.Authorization;
  }
};

export default apiClient;
